<div class="top-items">
  @if (darkModeService.dealerLogo) {
  <div class="logo">
    <img [src]="darkModeService.dealerLogo" />
  </div>
  }
  <ng-content select="[workspaces]"></ng-content>
</div>
<div class="bottom-items">
  <div>
    <ng-content select="[lang-selector]"></ng-content>
    <ngx-logout></ngx-logout>
    <ngx-dark-mode-toggle></ngx-dark-mode-toggle>
  </div>
</div>
